/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Beweegactiviteitenreeks_Api_Errors_Beweegdoel_RequiredInputs */

const nl_beweegactiviteitenreeks_api_errors_beweegdoel_required = /** @type {(inputs: Beweegactiviteitenreeks_Api_Errors_Beweegdoel_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er moet minimaal één beweegdoel worden geselecteerd`)
};

/**

* @param {Beweegactiviteitenreeks_Api_Errors_Beweegdoel_RequiredInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const beweegactiviteitenreeks_api_errors_beweegdoel_required = /** @type {((inputs?: Beweegactiviteitenreeks_Api_Errors_Beweegdoel_RequiredInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Beweegactiviteitenreeks_Api_Errors_Beweegdoel_RequiredInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_beweegactiviteitenreeks_api_errors_beweegdoel_required(inputs)
});
export { beweegactiviteitenreeks_api_errors_beweegdoel_required as "beweegactiviteitenreeks.api_errors.beweegdoel_required" }